import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    container: {
        display: 'flex',
        alignItems: 'center',
        marginRight: '15px',
        width: '140px',
        height: '38px',
    },

    nombreArchivo: {
        fontSize: '12px',
        color: '#02599E',
        lineHeight: '14px',
        letterSpacing: '-0.04em',
        whiteSpace: 'nowrap',
    },

    descargable: {
        cursor: 'pointer',
    },

    containerEliminar: {
        marginLeft: 'auto',
        '&:focus': {
            outline: 'none',
        },
    },

    containerAdjunto: {
        marginRight: '10px',
        cursor: 'default',
    },
});
